import React from 'react';
import EyeIcon from 'ps-react-chadacious/EyeIcon';

/** Custom message */
export default function Example() {
    return <EyeIcon />
}


// WEBPACK FOOTER //
// ./src/docs/examples/EyeIcon/Example.js